module.exports = __webpack_public_path__ + "static/img/marmalade_pictgrid17_960x872.b8ceb6c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/marmalade_pictgrid17_960x872.jpg
// module id = nnvL
// module chunks = 0